import { Button, DateField, Icons, Modal, ShowButton, Table, Tag, useModal } from '@pankod/refine-antd'
import { useTranslate } from '@pankod/refine-core'
import { QueryObserverResult } from '@tanstack/react-query'
import { definitions, Orders } from 'interfaces'
import { useEffect } from 'react'
import { capitalizeFirstLetter, currency, DEFAULT_DATE_TIME_FORMAT, getColorLabel } from 'utility'

type ModalProps = {
  orders: Orders[]
  tableQueryResult: QueryObserverResult
}

export const UserOrdersModal: React.FC<ModalProps> = ({ orders, tableQueryResult }) => {
  const { modalProps, show } = useModal()
  const t = useTranslate()

  useEffect(() => {
    if (modalProps.visible) {
      tableQueryResult.refetch()
    }
  }, [modalProps.visible])

  return (
    <>
      <Button onClick={show} size="small" className="ant-btn ant-btn-primary">
        <Icons.ShoppingOutlined />
      </Button>

      <Modal
        {...modalProps}
        title={t('order.orders')}
        centered
        footer={null}
        style={{ minWidth: '50svw' }}
      >
        <Table dataSource={orders} rowKey={(record) => record.id} style={{ marginTop: 24 }}>
          <Table.Column
            key="id"
            dataIndex="id"
            title={t('order.fields.id')}
            align="center"
            render={(value) => (
              <ShowButton
                resourceNameOrRouteName='orders'
                recordItemId={value}
              >
                {`#${value}`}
              </ShowButton>
            )}
          />
          <Table.Column
            key="alias"
            dataIndex="alias"
            title={t('order.fields.alias')}
            align="center"
          />
          <Table.Column
            key="created_at"
            dataIndex="created_at"
            title={t('order.fields.createdAt')}
            align="center"
            render={(value) => <DateField value={value} format={DEFAULT_DATE_TIME_FORMAT} />}
          />
          <Table.Column
            key="marketplace_id"
            dataIndex={['marketplace_id', 'name']}
            title={t('order.fields.marketplace')}
            align="center"
          />
          <Table.Column
            key="total"
            dataIndex="total"
            title={t('order.fields.total')}
            align="center"
            render={(value) => currency(value)}
          />
          <Table.Column
            key="status_id_name"
            dataIndex={['status_id_name', 'name']}
            title={t('order.fields.status')}
            align="center"
            render={(value, record: definitions['orders']) => (
              <Tag color={getColorLabel(value, record?.prev_status_id)}>
                {capitalizeFirstLetter(value)}
              </Tag>
            )}
          />
        </Table>
      </Modal>
    </>
  )
}
